define('plugin/package/view/PackageIndexLayout',['require','lib/view/LayoutView','plugin/package/view/PackageCollectionView','plugin/package/view/PackageFilterView','view/module/MessageView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var PackageCollectionView = require('plugin/package/view/PackageCollectionView');
    var PackageFilterView = require('plugin/package/view/PackageFilterView'); 
    var MessageView = require('view/module/MessageView');

    /**
     * Package index layout view
     *
     * @class PackageIndexLayout
     */
    return LayoutView.extend({

        template: '#package_index_layout',
        regions: {
            'list': '#sb_package_list_container',
            'status': '#sb_package_status_message',
            'filter': '#sb_package_filter_container',
        },

        onShow: function () {
            var filter = this.getOption('filterData');
            if (!filter) {
                filter = {};
            }
            if (filter.services) {
                filter.services = filter.services.split(',');
            }
            if (filter.products) {
                filter.products = filter.products.split(',');
            }

            this.showChildView('list', new PackageCollectionView({
                collection: this.collection,
                serviceCollection: this.getOption('serviceCollection'),
                productCollection: this.getOption('productCollection'),
                attributeCollection: this.getOption('attributeCollection'),
                filterData: filter,
            }));

            if (this.getOption('withFilter')) {
                this.showChildView('filter', new PackageFilterView({
                    collection: this.getOption('serviceCollection'),
                    productCollection: this.getOption('productCollection'),
                    attributeCollection: this.getOption('attributeCollection'),
                    filterData: filter
                }));
            }
        },

        showErrorMessage: function (error) {
            this.showChildView('status', new MessageView({
                type: 'danger',
                message: error
            }));

            Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
        }

    });

});
